import * as React from 'react';

import styles from './index.css';
import { trackShowFullInfoClick } from '../../../tracking';
import { ClipboardModify } from '../../common/ClipboardModify';
import { Description } from '../../common/description';
import { Card } from '../card';

export interface IDescriptionLayoutStateProps {
  description: string;
  joinBottom: boolean;
}

type TDescriptionLayoutProps = IDescriptionLayoutStateProps;

export class DescriptionLayout extends React.Component<TDescriptionLayoutProps> {
  public render() {
    const { description, joinBottom } = this.props;

    return (
      <Card joinTop joinBottom={joinBottom}>
        <ClipboardModify>
          <div className={styles['title']}>Описание</div>
          <Description
            description={description}
            lineCounter={5}
            onShowFullInfoClick={() => trackShowFullInfoClick('KP_info_open')}
            verticalShadow
            showArrow
            moreText="Читать полностью"
          />
        </ClipboardModify>
      </Card>
    );
  }
}
